import { Tooltip } from './Tooltip'

interface TruncatedTextProps {
  text: string
  maxLength?: number
  className?: string
  showTooltip?: boolean
}

export function TruncatedText({ 
  text, 
  maxLength = 20, 
  className = '', 
  showTooltip = true 
}: TruncatedTextProps) {
  const shouldTruncate = text.length > maxLength
  const truncatedText = shouldTruncate ? `${text.slice(0, maxLength)}...` : text

  if (!shouldTruncate || !showTooltip) {
    return <span className={className}>{truncatedText}</span>
  }

  return (
    <Tooltip content={text}>
      <span className={`${className} cursor-help`}>
        {truncatedText}
      </span>
    </Tooltip>
  )
}